<template>
  <div class="app-auth">
    <div class="app-auth__content">
      <img src="/statics/logo.svg" alt="">
      <p v-if="hasError" class="error-message">
        {{ $t('Email or Password is incorrect') }}
      </p>
      <p v-else>
        {{ title }}
      </p>
      <el-form ref="ruleForm"
               :status-icon="true"
               :rules="validationRules"
               :model="model"
               label-position="right"
               @submit.native.prevent="submitForm('ruleForm')">
        <el-form-item :label="$t('Username')"
                      prop="username">
          <el-input v-model="model.username" />
        </el-form-item>
        <el-form-item :label="$t('Password')"
                      prop="password">
          <el-input v-model="model.password" type="password" />
        </el-form-item>
        <el-button :loading="Auth.isLoading"
                   type="primary"
                   native-type="submit">
          {{ $t('Sign in') }}
        </el-button>
      </el-form>
      <div class="redirect-links">
        <router-link to="/forgot-password">
          {{ $t('Forgot Password') }}
        </router-link>
      </div>
    </div>
    <a class="privacy-policy"
       href="https://vispera.co/privacy-policy"
       target="_blank">
      {{ $t('Privacy Policy') }}
    </a>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import posthog from 'posthog-js';
import i18n from '@/i18n';
import projectName from '@/helpers/projectName';

export default {
  name: 'Login',
  data() {
    return {
      validationRules: {
        username: {
          required: true, message: this.$t('Please input username'), trigger: 'blur'
        },
        password: {
          required: true, message: this.$t('Please input password'), trigger: 'blur'
        }
      },
      model: {
        username: '',
        password: ''
      }
    };
  },
  computed: {
    ...mapState(['Auth', 'Account', 'route']),
    hasError() {
      return this.Auth.hasError || this.Account.active.hasError;
    },
    title() {
      return this.Auth.isLoading || this.Account.active.isLoading ? this.$t('Please wait... We are checking your account') : this.$t('Welcome, Sign in to your account');
    }
  },
  created() {
    i18n.locale = window.navigator.language;
  },
  methods: {
    ...mapActions(['fetchToken', 'fetchAccount']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    async login() {
      try {
        await this.fetchToken(this.model);
        await this.fetchAccount().then((user) => {
          // eslint-disable-next-line no-undef
          posthog.identify(
            `${projectName()}_user_${user.data.id}`,
            { email: `${projectName()}_user_${user.data.id}` }
          );

          // eslint-disable-next-line func-names
          (function (w, d, s) {
            const a = d.getElementsByTagName('head')[0];
            const r = d.createElement('script');
            r.async = 1;
            r.src = s;
            r.setAttribute('id', 'usetifulScript');
            r.dataset.token = 'c4ddfa98cbee832ddce511f0c3a4c40e';
            a.appendChild(r);
          }(window, document, 'https://www.usetiful.com/dist/usetiful.js'));
        });
        const { redirect } = this.route.query;
        this.$router.push(redirect || '/');
      } catch (error) {
        if (error.response.data.error === 'locked_account') {
          this.$notify.error({
            title: 'Error',
            message: i18n.t('Your account has been locked because of unsuccessful login attempts. Please try again in 5 minutes and contact your customer representative if the problem persists.')
          });
        } else if (error.response.data.error === 'disabled_account') {
          this.$notify.error({
            title: 'Error',
            message: i18n.t("This user's account has been disabled by the administrator")
          });
        }
      }
    }
  }
};
</script>
